export enum DAY_OF_WEEK {
    SUNDAY = 0,
    MONDAY = 1,
    TUESDAY = 2,
    WEDNESDAY = 3,
    THURSDAY = 4,
    FRIDAY = 5,
    SATURDAY = 6,
}

export enum FEE_APPLICATION_METHOD {
    BASE_PRICE = 'basePrice',
    TOTAL_PRICE = 'totalPrice',
}
